import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
const SearchParamsSchema = z.object({
    tab: z.enum([
        'configuration',
        'deploymentIntegrations',
        'variables',
        'dependencies',
        'members',
        'logs'
    ]).optional()
});
// Will be lazy loaded from MFE
export const Route = createFileRoute('/org/$organization/$project/$application/devops/environment/$environment')({
    validateSearch: (search)=>SearchParamsSchema.parse(search),
    component: ()=>null
});
